var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreativeConsultingV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.1 113.3",
    style: {
      enableBackground: "new 0 0 290.1 113.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,29.9c0-3.8-0.8-8.5-4.4-9.5c-2.1-0.5-4.3,0.6-5.7,2.3s-1.9,3.9-2.2,6.1c-0.5,2.9-0.5,5.9-0.6,8.9 c-0.1,3.3,0.3,7.2,3.1,8.8c1.6,0.9,3.8,0.7,5.2-0.6s1.9-3.3,1.3-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,47.9c-0.1,0.5-0.2,1-0.3,1.5c-0.6-9.1-0.6-18.3,1.4-26.5c2.5-2.2,6.8-1.7,9,0.8c2.2,2.5,2.1,6.6,0,9.2 c-2.1,2.6-6,3.4-9.1,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.9,36.3c1.3,4.2,2.6,8.3,3.9,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.4,22c0.1,8.7,0.2,17.4,0.4,26.1c3.2-1,6.5-1.4,9.8-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.7,34.2l8.2,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.1,21.7h10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.1,50.3c0.8-9.5,1.5-19,2.2-28.5c2.8-0.4,5.6-0.2,8.4,0.5c1.3,8.5,3,16.9,3.4,25.5c0,0.3,0.1,0.8,0.5,0.8 c0.3,0,0.2-0.7,0-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.5,37.2c2.4-0.2,4.9-0.4,7.3-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.1,22.3c4.1,0.1,8.1-0.1,12.1-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.6,24.4c-1.3,8.9-1.6,17.9-1,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.4,26c0.1-2.1,0.1-4.2,0.2-6.2c-0.3,10-0.3,20,0.1,30c0-0.8,0-1.6,0-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.7,22.1c1.5,9.2,4.4,18.2,8.7,26.5c1.4-9.2,3.2-18.3,5.4-27.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.1,22c0.4,8.7,0.8,17.4,1.2,26.1c3.2-2.3,7.4-3.2,11.3-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.6,36c3.8-1.1,7.6-1.7,11.6-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.6,21.7c3.2-1.3,6.6-1.8,10-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,73.2c0-3.8-0.8-8.5-4.4-9.5c-2.1-0.5-4.4,0.6-5.7,2.3s-1.9,3.9-2.2,6.1C20.1,75,20,78,19.9,81 c-0.1,3.3,0.3,7.2,3.1,8.8c1.6,0.9,3.8,0.7,5.2-0.6s1.9-3.3,1.3-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.7,66.5c4.1,0.1,8.1-0.1,12.1-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.2,68.6c-1.3,8.9-1.6,17.9-1,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,67.9c0.3,8.2,0.2,16.4-0.3,24.6c0,0.3,0,0.7,0.3,0.8s0.4-0.5,0.1-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.7,64.8c-1.4-0.6-3,0-4.1,1c-1.1,1-1.7,2.4-2.2,3.8c-1.3,3.6-1.9,7.5-1.8,11.4c0.1,2.1,0.4,4.2,1.6,5.9 s3.5,2.7,5.5,1.9c1.9-0.8,2.7-2.9,3.2-4.9c0.8-2.9,1.4-5.8,1.8-8.8c0.3-2.1,0.5-4.4-0.3-6.4C58.6,66.9,56.6,65.2,55.7,64.8 L55.7,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.2,67.4c-0.1,7.8,0.1,15.6,0.6,23.4c3.5-1.1,7.2-1.4,10.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.2,67.8c-1.5-1.1-3.2-2.2-5.1-2.1c-1.6,0-3.1,0.9-4,2.2c-1,1.3-1.4,2.8-1.5,4.4c-0.1,1.1,0,2.3,0.7,3.2 c1.1,1.5,3.2,1.6,4.9,2.5c2.1,1.1,3.2,3.4,3.8,5.7c0.2,0.6,0.3,1.3,0.2,2c-0.2,0.9-0.8,1.7-1.6,2.2c-1.2,0.9-2.7,1.3-4.1,1.1 s-2.8-1.2-3.3-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.4,70.2c-0.2-1.7-1.8-3-3.5-3.3s-3.5,0.2-5,1c-0.7,0.3-1.4,0.7-1.8,1.4c-0.4,0.5-0.5,1.2-0.6,1.9 c-1,5-1.1,10.2-0.4,15.2c0.1,1.1,0.4,2.2,1,3.2c1.3,1.8,3.9,2.1,6.1,2.1c1.3,0,2.7,0,3.6-0.9c0.5-0.5,0.8-1.2,1-1.9 c0.6-2.2,0.8-4.4,0.5-6.6c-1.5,0.4-3.2,0.5-4.7,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.6,94.7c1.1-8.9,1.4-18,0.8-27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233,66.4c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.1,14.7,8.3,21.2c-0.1-9.2-0.2-18.4-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233,66.4c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.1,14.7,8.3,21.2c-0.1-9.2-0.2-18.4-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.3,91c1.2-8.9,1.4-18,0.8-27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.7,62.8c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.2,14.6,8.3,21.2l-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.7,62.8c0.8,2.3,1.6,4.5,2.4,6.8c2.6,7.3,5.2,14.6,8.3,21.2l-0.2-27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.5,67.3c0.4,5.3,0.8,10.5,1.2,15.8c0.1,1.6,0.2,3.2,0.4,4.8c0.1,0.7,0.1,1.4,0.5,2 c0.8,1.3,2.7,1.4,4.2,1.3c1.1-0.1,2.4-0.2,3.2-0.9c0.8-0.8,1-2,1.1-3.1c0.8-6.7,1-13.4,0.7-20.2"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1 animate-svg-no-children",
    d: "M7.2,12.1C97.7,8.7,191,9.3,281.4,13.8c2.8,30.2,3,60.7,0.6,91c-92.3-0.6-183.5-1.9-275.8-2.6 c2.3-15.1,0.8-26,0.3-41.7C6.2,52,6.6,42.5,6.8,34C6.9,26.7,7.1,20,7.2,12.1z",
    style: {
      animationDelay: "6s",
      animationDuration: "1s"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeConsultingV2);
export default __webpack_public_path__ + "static/media/creative-consulting-v2.67d9ee8c0d38198e216b8063be630ca7.svg";
export { ForwardRef as ReactComponent };